import {
    type BankDetailsRequestPart,
    type BankDetailsResponseModel,
    type BankingModel,
    EventTypeEnum,
} from "@/models";
import axios from "axios";
import { defineStore } from "pinia";
import { useDataLayerStore } from "./dataLayer.store";
import { useGlobalStore } from "./global.store";

export const useBankingStore = defineStore("banking", {
    state: (): BankingModel => {
        return {
            validBank: null,
            showAddress: false,
            directDebitDay: 0,
            accountNumber: "",
            sortCode: "",
            bankName: "",
            branch: "",
            accountHolder: "",
            manualAddress: false,
            address: {
                line1: "",
                line2: "",
                line3: "",
                postcode: "",
            },
        };
    },
    getters: {
        dataLayer: () => {
            return useDataLayerStore();
        },
        global: () => {
            return useGlobalStore();
        },
    },
    actions: {
        showManualAddress(show: boolean, triggerEvent: boolean): void {
            if (triggerEvent) {
                this.dataLayer.triggerEvent(
                    EventTypeEnum.PageInteraction,
                    `btn|manual bank address ${show ? "open" : "close"}`
                );
            }
            this.manualAddress = show;
        },
        async bankLookup(): Promise<boolean> {
            try {
                const response = await axios.get<BankDetailsResponseModel>(
                    `${this.global.env.API_URL}/api/v2/address/bank/${this.sortCode}/${this.accountNumber}`
                );

                if (response.status === 200) {
                    this.bankName = response.data.bank;
                    this.address.line1 = response.data.line1;
                    this.address.line2 = response.data.line2;
                    this.address.line3 = response.data.line3;
                    this.address.postcode = response.data.postcode;
                    this.branch = response.data.branch;
                    return true;
                }

                return false;
            } catch {
                return false;
            }
        },
        bankDetailsRequestPart(): BankDetailsRequestPart {
            return {
                bankName: this.bankName,
                sortCode: this.sortCode,
                accountNumber: this.accountNumber,
                accountHolder: this.accountHolder,
                collectionDay: this.directDebitDay.toString().padStart(2, "0"),
                address: {
                    postcode: this.address.postcode.toUpperCase(),
                    line1: this.address.line1,
                    line2: this.address.line2,
                    line3: this.address.line3,
                },
            };
        },
    },
});
